<form [formGroup]="pressureForm" (ngSubmit)="onSubmit()">

    <div class="p-5">
        <div class="flex justify-center items-baseline flex-wrap">
          <div class="flex m-2">
            <mat-form-field [hideRequiredMarker]="true">      
              <mat-label><i>k</i> value</mat-label>      
              <input matInput formControlName="gammaVal" autocomplete="off">
              <mat-error *ngIf="pressureForm.invalid && pressureForm.touched">
                <span class="myerror">1.0 &lt; <i>k</i> &le; 1.67</span>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="flex m-2">
            <mat-form-field [hideRequiredMarker]="true">       
              <mat-label>Pressure ratio</mat-label>     
              <input matInput formControlName="pressureVal" autocomplete="off">
              <mat-error *ngIf="pressureForm.invalid && pressureForm.touched">
                Pressure ratio should be less than 1
              </mat-error>
            </mat-form-field>
          </div>  
        </div>
    
        <div class="sbmtArea flex justify-center items-baseline flex-wrap">
          <button mat-raised-button type="submit" [disabled]="pressureForm.invalid">Calculate</button>
        </div>
    
       
      </div>
    
</form>

<div class="flex justify-center items-baseline flex-wrap" *ngIf="pBool">
    <table>
      <tr>
        <td>
            Mach
        </td>
        <td> 
            <span class="asana2">{{ isenMach()}}</span> 
        </td>
      </tr>
      <tr>
        <td>
            T / T<sub>0</sub>
        </td>
        <td>
            <span class="asana2">{{ isenT_Tt() | number:'.1-5' }}</span>
        </td>
      </tr>
      <tr>
        <td>
            <span>A / A<sub>t</sub></span>
        </td>
        <td>
            <span class="asana2">{{ isenA_As() | number:'.1-5'}}</span>
        </td>
      </tr>
      <tr>
        <td>
            pA / p<sub>0</sub> A*
        </td>
        <td>
          <span class="asana2">{{ isenpA_ptAstar()  | number:'.1-5'  }}</span>
        </td>
      </tr>
      <tr>
        <td>
            <span>Prandtl-Meyer flow (ν)</span>

        </td>
        <td>
            <span class="asana2">{{ isenpm() | number:'.1-5' }}</span>
        </td>
      </tr>
      <tr>
        <td>
            <span>Mach angle (μ)</span>      
        </td>
        <td>
          <span class="asana2">{{ isenmach_angle() | number:'.1-5' }}</span>
          
        </td>
      </tr>
      <tr>
        <td>
          <!-- CFopt -->
          <span>C<sub>Fopt</sub></span>

        </td>
        <td>
          <span class="asana2">{{isen_cfopt() | number:'.1-5' }}</span></td>
      </tr>
      <tr>
        <td>
            <span>ρ/ρ<sub>0</sub></span>
    
            <!-- rt/rt -->
        
        </td>
        <td>
            <span class="asana2">{{ isen_rhot() | number:'.1-5' }}</span>
        </td>
      </tr>
    </table>
  </div>